<template>
  <div class="admin-loader" v-if="loading">
    <div></div>
    <div></div>
    <div></div>
    <p>
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: "admin-loader",

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: "Chargement en cours ..."
    }
  },

  data() {
    return {};
  }
};
</script>
